
export const Theme = {
  typography: 'leading-tight'
};

export const TypographyVariants = {
  h1: [
    'text-8xl font-semibold text-black',
    'dark:text-white'
  ],
  h2: [
    'text-6xl font-semibold text-black',
    'dark:text-white'
  ],
  h3: [
    'text-4xl font-semibold text-black',
    'dark:text-white'
  ],
  h4: [
    'text-2xl font-semibold text-black',
    'dark:text-white'
  ],
  h5: [
    'ws:text-sm text-xl font-semibold text-black',
    'dark:text-white'
  ],
  h6: [
    'text-lg font-semibold text-black',
    'dark:text-white'
  ],
  subtitle1: [
    'text-md text-gray-900',
    'dark:text-gray-200'
  ],
  subtitle2: [
    'text-md text-gray-900 font-semibold',
    'dark:text-gray-200'
  ],
  body1: [
    'ws:text-xs text-base text-gray-800',
    'dark:text-gray-300'
  ],
  body2: [
    'ws:text-xs text-base font-semibold text-gray-800',
    'dark:text-gray-300'
  ],
  caption: [
    'text-xs text-gray-400',
    'dark:text-gray-500'
  ]
};
